import api from "core/services/api";

const useLogout = () => {
  const logout = async () => {

    const apiUrl = "/user/logout";
    api
      .post(apiUrl)
      .then(() => {
        localStorage.clear();
        window.location.reload();
        window.location.href = "/";
      })
  };

  return {
    logout,
  };
};

export default useLogout;
